import ApiService from "./../../api/api.service";

const ArquivoRetornoService = {
  listar(form) {
    return ApiService.get(`ArquivoRetorno/listar-arquivos-retorno/?${form}`);
  },
};

export default ArquivoRetornoService;
